// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-Common-Pagination-index-root-1x6oG","content":"src-components-Common-Pagination-index-content--pPzz","nav":"src-components-Common-Pagination-index-nav-3_g2t","item":"src-components-Common-Pagination-index-item-X-wnf","itemActive":"src-components-Common-Pagination-index-itemActive-19q14 src-components-Common-Pagination-index-item-X-wnf","dotItem":"src-components-Common-Pagination-index-dotItem-1VJbS src-components-Common-Pagination-index-item-X-wnf"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Common/Pagination/index.css
 ** module id = 263
 ** module chunks = 0
 **/